<template>
    <section id="pc-specs-section" class="row section-global pc-specs">
        <div class="container">
            <div class="row">
                <div class="row hidden-md hidden-lg text-center m-y-md">
                    <div class="col-xs-12">
                        <h1>{{ sectionData.title }}</h1>
                    </div>
                </div>
                <div class="col-xs-12 col-md-5">
                    <img :src="sectionData.image_url" class="img-responsive">
                </div>
                <div class="col-xs-12 col-md-7">
                    <div class="hidden-xs hidden-sm">
                        <h1>{{ sectionData.title }}</h1>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6">
                            <ul>
                                <li>{{ sectionData.products.cases.name }} {{ sectionData.products.cases.quantity > 1 ? `(${sectionData.products.cases.quantity})`: '' }} <small>CASE</small></li>
                                <li>{{ sectionData.products.motherboards.name }} {{ sectionData.products.motherboards.quantity > 1 ? `(${sectionData.products.motherboards.quantity})`: '' }} <small>MOBO</small></li>
                                <li>{{ sectionData.products.cpus.name }} {{ sectionData.products.cpus.quantity > 1 ? `(${sectionData.products.cpus.quantity})`: '' }} <small>CPU</small></li>
                                <li>{{ sectionData.products.coolers.name }} {{ sectionData.products.coolers.quantity > 1 ? `(${sectionData.products.coolers.quantity})`: '' }} <small>CPU COOLER</small></li>
                                <li>{{ sectionData.products.gpus.name }} {{ sectionData.products.gpus.quantity > 1 ? `(${sectionData.products.gpus.quantity})`: '' }} <small>GPU</small></li>
                                <li>{{ sectionData.products.ram.name }} {{ sectionData.products.ram.quantity > 1 ? `(${sectionData.products.ram.quantity})`: '' }} <small>RAM</small></li>
                            </ul>
                        </div>
                        <div class="col-xs-12 col-sm-6">
                            <ul>
                                <li v-for="(disk, index) in sectionData.products.ssd"
                                    :key="'ssd-' + index">
                                    {{ disk.name }}
                                    <template v-if="disk.quantity > 1">
                                        ({{ disk.quantity }})
                                    </template>
                                    <small>SSD</small>
                                </li>
                                <li v-for="(disk, index) in sectionData.products.hdd"
                                    :key="'hdd-' + index">
                                    {{ disk.name }}
                                    <template v-if="disk.quantity > 1">
                                        ({{ disk.quantity }})
                                    </template>
                                    <small>HDD</small>
                                </li>
                                <li>
                                    {{ sectionData.products.psus.name }}
                                    <small>PSU</small>
                                </li>
                                <li v-for="(fan, index) in sectionData.products.fans"
                                    :key="'fans-' + index">
                                    {{ fan.name }}
                                    <template v-if="fan.quantity > 1">
                                        ({{ fan.quantity }})
                                    </template>
                                    <small>FAN</small>
                                </li>
                                <li v-for="(extra, index) in sectionData.products.extras"
                                    :key="'extras-' + index">
                                    {{ extra.name }}
                                    <small>EXTRA</small>
                                </li>
                                <li v-for="(peripheral, index) in sectionData.products.peripherals"
                                    :key="'peripherals-' + index">
                                    {{ peripheral.name }}
                                    <small>PERIPHERAL</small>
                                </li>
                                <li v-for="(monitor, index) in sectionData.products.monitors"
                                    :key="'monitors-' + index">
                                    {{ monitor.name }}
                                    <template v-if="monitor.quantity > 1">
                                        ({{ monitor.quantity }})
                                    </template>
                                    <small>MONITOR</small>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <a @click="$emit('scroll-to', sectionButtons.landing_page_buttons[0].url)" href="#" class="btn btn-green m-y-md">
                        {{ sectionButtons.landing_page_buttons[0].text }}
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "PcSpecsSection",
    props: {
        sectionData: {
            type: Object,
            required: true
        },
        sectionButtons: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
.pc-rental {
    .pc-specs {
        overflow: hidden;
        background-color: white;
        padding-top: 40px;

        .container {
            > .row {
                display: flex;
                align-items: center;
            }
        }

        h1 {
            font-style: 48px;
            margin-bottom: 0;
            text-transform: uppercase;
        }

        .price {
            font-size: 20px;
            font-weight: 700;
        }

        img {
            margin: 0 auto;
        }

        ul {
            padding-left: 0;
            list-style-type: none;
            margin-top: 40px;
            margin-bottom: 0;

            li {
                font-weight: 700;
                padding-bottom: 10px;
                font-size: 15px;
                text-transform: uppercase;

                small {
                    font-weight: normal;
                    color: #afafaf;
                }
            }
        }

        @media screen and (max-width: 992px) {
            padding: 10px;

            .container {
                > .row {
                    display: block;
                }
            }

            .btn {
                width: 100%;
            }
        }

        @media screen and (max-width: 768px) {
            ul {
                margin-top: 0;
            }
        }
    }
}
</style>
